"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Typography_1 = require("@material-ui/core/Typography");
const Card_1 = require("@material-ui/core/Card");
const CardActionArea_1 = require("@material-ui/core/CardActionArea");
const CardContent_1 = require("@material-ui/core/CardContent");
const CardMedia_1 = require("@material-ui/core/CardMedia");
const styles_1 = require("@material-ui/core/styles");
const classnames_1 = require("classnames");
const react_i18next_1 = require("react-i18next");
const assets_1 = require("../config/assets");
const Icon_1 = require("../icon/Icon");
const ArcadeCurrency_1 = require("./ArcadeCurrency");
const styles = (theme) => (0, styles_1.createStyles)({
    card: {
        borderRadius: 10,
        backgroundColor: theme.palette.primary.dark.getWithAlpha(0.7)
    },
    root: {
        display: 'flex',
        justifyContent: 'normal',
        alignItems: 'normal'
    },
    arcadeCardContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2)
        },
        ['@media (max-width:375px)']: {
            padding: theme.spacing()
        }
    },
    tokens: {
        display: 'flex',
        alignItems: 'center'
    },
    listItems: {
        display: 'flex',
        alignItems: 'center'
    },
    bullet: {
        fontSize: 5,
        marginRight: theme.spacing(0.5)
    },
    title: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        width: 275,
        [theme.breakpoints.down('lg')]: {
            width: 185
        },
        [theme.breakpoints.down('md')]: {
            width: 392
        },
        [theme.breakpoints.down('sm')]: {
            width: 183
        },
        ['@media (max-width:375px)']: {
            width: 169
        },
        ['@media (max-width:320px)']: {
            width: 145
        }
    },
    media: {
        height: 220,
        width: 220,
        display: 'flex',
        position: 'relative',
        [theme.breakpoints.down('md')]: {
            height: 250,
            width: 250
        },
        [theme.breakpoints.down('sm')]: {
            height: 180,
            width: 180
        },
        ['@media (max-width:375px)']: {
            height: 160,
            width: 160
        }
    }
});
const ArcadeRewardCard = ({ image, title, list, tokens, onPress, classes }) => {
    const onClick = () => {
        onPress();
    };
    const imageUrl = !!image ? image : assets_1.assets.internalAssets.noImage;
    list = list.sort((a, b) => (a.key > b.key ? 1 : -1));
    const { t } = (0, react_i18next_1.useTranslation)();
    const renderItem = (item, index) => {
        if (item.key.startsWith('summary')) {
            return ((0, jsx_runtime_1.jsxs)(Typography_1.default, Object.assign({ color: "primary", variant: "body2", className: classes.listItems }, { children: [(0, jsx_runtime_1.jsx)(Icon_1.default, { iconName: 'fiber_manual_record', iconType: 'material', className: classes.bullet }), item.value] }), index));
        }
        else
            return null;
    };
    return ((0, jsx_runtime_1.jsx)(Card_1.default, Object.assign({ onClick: onClick, className: (0, classnames_1.default)('po-widget-card', classes.card) }, { children: (0, jsx_runtime_1.jsxs)(CardActionArea_1.default, Object.assign({ className: classes.root }, { children: [(0, jsx_runtime_1.jsx)(CardMedia_1.default, { className: classes.media, image: imageUrl }), (0, jsx_runtime_1.jsxs)(CardContent_1.default, Object.assign({ className: classes.arcadeCardContainer }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.tokens }, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ color: "primary", variant: "overline" }, { children: t('arcade.redeemFor', { amount: tokens.toPointsFormat() }) })), (0, jsx_runtime_1.jsx)(ArcadeCurrency_1.default, { color: 'secondary', size: 14 })] })), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ color: "secondary", variant: "h6", className: classes.title, component: 'p' }, { children: title })), list && list.length > 0 ? list.map((item, index) => renderItem(item, index)) : null] }))] })) })));
};
exports.default = (0, styles_1.withStyles)(styles)(ArcadeRewardCard);
//# sourceMappingURL=ArcadeRewardCard.js.map